export const BigButton = ({ icon: Icon, label, sub, onClick, color = "#4accff", variant = "solid", disabled, active, testId, className = "", subClassName = "" }) => {
  const solid = variant === "solid" || active;
  const isWhite = color === "#ffffff";
  const border = isWhite ? "var(--nv-fg)" : color;
  return (
    <button
      type="button"
      data-testid={testId}
      onClick={onClick}
      disabled={disabled}
      className={`nv-press min-h-[72px] w-full rounded-2xl px-5 py-4 flex items-center gap-4 text-left border-2 disabled:opacity-40 disabled:cursor-not-allowed ${className}`}
      style={{
        background: solid ? (isWhite ? "var(--nv-fg)" : color) : "var(--nv-btn-bg)",
        borderColor: border,
        color: solid ? (isWhite ? "var(--nv-bg)" : color === "#4accff" ? "#0b0f17" : "#ffffff") : "var(--nv-fg)",
        boxShadow: active && !isWhite ? `0 0 0 4px ${color}40, 0 10px 30px -10px ${color}` : undefined,
      }}
    >
      {Icon && <Icon className="h-8 w-8 shrink-0" strokeWidth={2.4} />}
      <span className="flex flex-col">
        <span className="font-display text-xl sm:text-2xl font-extrabold uppercase tracking-wide leading-tight">{label}</span>
        {sub && <span className={`text-sm opacity-80 font-medium leading-snug ${subClassName}`}>{sub}</span>}
      </span>
    </button>
  );
};
